import { Errors } from '../../tradebuilder-v2/util'

const GENERIC_ERROR_MESSAGE =
  'Something went wrong. The form could not be submitted. If the problem persists, please contact support.'

const VALUATION_WINDOW_TRIGGER = 'new information cut-off'

const VALUATION_WINDOW_MESSAGE =
  'Unable to activate account between the new information expiry and the end of the valuation cycle. Please try again in 10 minutes.'

export const parseApproveErrors = (response: any): Errors => {
  const errors: Errors = {}

  if (response?.status === 422) {
    const approveErrors = response.error
    if (Array.isArray(approveErrors) && approveErrors.length > 0) {
      approveErrors.forEach(e => {
        if (typeof e === 'string') {
          try {
            const parsed = JSON.parse(e)
            if (parsed.Code != null && typeof parsed.Description === 'string') {
              errors[String(parsed.Code)] = parsed.Description
            }
          } catch {
            // ignore unparseable entries
          }
        } else if (e?.code != null && e?.description != null) {
          errors[e.code] = e.description
        }
      })
      if (Object.keys(errors).length > 0) {
        return errors
      }
    }
  }

  const serverMessage: string | undefined =
    response?.error?.InnerException?.Message ?? response?.error?.Message

  if (serverMessage?.includes(VALUATION_WINDOW_TRIGGER)) {
    errors.approveError = VALUATION_WINDOW_MESSAGE
    return errors
  }

  errors.approveError = GENERIC_ERROR_MESSAGE
  return errors
}
